export default {
  root: {},
  elevation1: {
    boxShadow: '0 0 10px 0px rgba(63,63,68,0.05)'
  }
};
